import api from "./api";

// 删除素材
export const materialItemDelete = async (itemIds: number[]) => {
  const res = await api.post<unknown>("/material_item/delete", {
    item_ids: itemIds,
  });
  return res;
};
